var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCatalogVar1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 4,
    height: 4,
    fill: "#456D64"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 7,
    width: 4,
    height: 4,
    fill: "#456D64"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 7,
    width: 4,
    height: 4,
    fill: "#456D64"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 13,
    width: 4,
    height: 4,
    fill: "#456D64"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 19,
    width: 4,
    height: 4,
    fill: "#456D64"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 19,
    width: 4,
    height: 4,
    fill: "#456D64"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 4,
    height: 4,
    fill: "#456D64"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 4,
    height: 4,
    fill: "#456D64"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 13,
    width: 4,
    height: 4,
    fill: "#456D64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogVar1);
export default __webpack_public_path__ + "static/media/catalog_var1.d9cd3793f511f8e1d7c240e66fd53555.svg";
export { ForwardRef as ReactComponent };